import { ColumnDef } from '@tanstack/react-table'
import { MoreHorizontal, Pencil, Trash2 } from 'lucide-react'
import { Button } from '@/common/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/common/ui/dropdown-menu'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import ToggleOtpProviderStatus from './components/ToggleOtpProviderStatus'
import type { components } from '@/schema'

type OtpProvider = components['schemas']['AdminOtpProviderResponse']

export const createOtpProviderColumns = (
	onEdit: (id: string) => void,
	onDelete: (id: string) => void,
): ColumnDef<OtpProvider>[] => [
	{
		accessorKey: 'name',
		header: 'ชื่อผู้ให้บริการ',
		cell: ({ row }) => {
			return <div className="font-medium">{row.original.name}</div>
		},
	},
	{
		accessorKey: 'otpKey',
		header: 'OTP Key',
		cell: ({ row }) => {
			const key = row.original.otpKey
			return (
				<div className="font-mono text-sm">
					{key.substring(0, 8)}...{key.substring(key.length - 4)}
				</div>
			)
		},
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => {
			return <ToggleOtpProviderStatus provider={row.original} />
		},
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => {
			return format(new Date(row.original.createdAt), 'dd MMM yyyy', {
				locale: th,
			})
		},
	},
	{
		accessorKey: 'updatedAt',
		header: 'อัปเดตล่าสุด',
		cell: ({ row }) => {
			return format(new Date(row.original.updatedAt), 'dd MMM yyyy HH:mm', {
				locale: th,
			})
		},
	},
	{
		id: 'actions',
		header: 'จัดการ',
		cell: ({ row }) => {
			return (
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="icon">
							<MoreHorizontal className="h-4 w-4" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="end">
						<DropdownMenuItem onClick={() => onEdit(row.original.id)}>
							<Pencil className="mr-2 h-4 w-4" />
							แก้ไข
						</DropdownMenuItem>
						<DropdownMenuItem
							onClick={() => onDelete(row.original.id)}
							className="text-destructive"
						>
							<Trash2 className="mr-2 h-4 w-4" />
							ลบ
						</DropdownMenuItem>
					</DropdownMenuContent>
				</DropdownMenu>
			)
		},
	},
]
